export const flatsPriceHidden = [
  'A.0.10',
  'B.0.05',
  'B.7.10',
  'B.7.11',
  'B.6.11',
  'B.1.7',
  'B.0.01',
];
